import { getRbacRolesOptions } from '@gozoki/api'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { ROLE_READ } from '~/components/routes/administration/roles/permissions'
import { RolesListTable } from '~/components/routes/administration/roles/roles-list-table'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/administration/roles/')({
  staticData: { permission: ROLE_READ },
  component: AdministrationRolesPage,
})
withRoutePermissions(Route)

function AdministrationRolesPage() {
  const navigate = Route.useNavigate()
  const { data: roles = [], isLoading } = useQuery(getRbacRolesOptions())

  return (
    <>
      <AppHeader>
        <Title>Administration</Title>
      </AppHeader>

      <AppContainer className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold">Rôles</h2>
            <p className="text-muted-foreground text-sm">Gestion des rôles et permissions RBAC.</p>
          </div>
        </div>

        <RolesListTable
          roles={roles}
          isLoading={isLoading}
          onCreateRole={() => navigate({ to: '/administration/roles/new' })}
        />
      </AppContainer>
    </>
  )
}
